export const wmES = {
  'skitouring': 'Esquí de travesía',
  'horse': 'A caballo',
  'walking': 'Caminata',
  'running': 'Correr',
  'cycling': 'Ciclismo',
  'poi_type': 'Puntos de interés',
  'where': 'Lugares',
  'lang': 'Idioma',
  'langPlaceholder': 'Seleccionar',
  'from': 'Inicio',
  'to': 'Fin',
  'ascent': 'Ascenso +',
  'descent': 'Descenso -',
  'distance': 'Distancia',
  'ele_from': 'Elevación de inicio',
  'ele_max': 'Elevación máxima',
  'ele_min': 'Elevación mínima',
  'ele_to': 'Elevación de llegada',
  'difficulty': 'Dificultad',
  'duration_forward': 'Duración de ida',
  'duration_backward': 'Duración de vuelta',
  'Filtri': 'Filtros',
  'Cerca': 'Buscar',
  'tracce': 'Rutas',
  'hiking': 'Senderismo',
  'Escursionismo': 'Senderismo',
  'escursionismo': 'Senderismo',
  'i miei percorsi': 'Dibujar ruta',
  'metri': 'Metros',
  'Vedi su OpenStreetMap': 'Ver en OpenStreetMap',
  'Descrizione Audio': 'Descripción de audio',
  'il tuo browser non supporta gli elementi audio': 'Tu navegador no soporta el elemento de audio.',
  'stampa': 'Imprimir',
  'Difficoltà': 'Dificultad',
  'Scala di difficoltà CAI': 'Escala de dificultad CAI',
  'Questo percorso non è accessibile': 'Esta ruta no es accesible',
  'Descrizione': 'Descripción',
  'Punto di partenza': 'Punto de partida',
  'Punto di arrivo': 'Punto de llegada',
  'Dettagli tecnici': 'Detalles técnicos',
  'Attività': 'Actividades',
  'Come arrivare': 'Cómo llegar',
  'Bici muscolari': 'Bicicletas convencionales',
  'Bici elettriche': 'Bicicletas eléctricas',
  'Mezzi pubblici': 'Transporte público',
  'Auto Propria': 'Automóvil propio',
  'Punti di interesse': 'POI',
  'Punto di interesse': 'POI',
  'Collegamenti esterni': 'Enlaces externos',
  'Downloads': 'Descargas',
  'edit geohub': 'Editar geohub',
  'NCC': 'NCC',
  'Filtri attivi': 'Filtros activos',
  'Reset filtri': 'Restablecer filtros',
  'Torna alla home': 'Volver a la página principal',
  'Risultati': 'Resultados',
  'Caricamento in corso.': 'Cargando.',
  'Spiacenti non ci sono risultati con questi criteri di ricerca.':
    'Lo sentimos, no hay resultados con estos criterios de búsqueda',
  'Bentornato!': 'Bienvenido de nuevo!',
  'Accedi con le tue credenziali per continuare.':
    'Inicie sesión con sus credenciales para continuar.',
  'E-mail': 'E-mail',
  "L'e-mail è obbligatoria": 'Se requiere correo electrónico',
  "Hai inserito un'e-mail non valida": 'Has introducido un correo electrónico no válido',
  'Password': 'Contraseña',
  'La password è obbligatoria': 'La contraseña es obligatoria',
  'Accedi': 'Acceso',
  'Hai dimenticato la password?': '¿Has olvidado tu contraseña?',
  'Accedi e scarica i tuoi percorsi preferiti': 'Inicia sesión y descarga tus rutas favoritas',
  'Puoi anche condividerli con i tuoi compagni di viaggio':
    'También puedes compartirlos con tus compañeros de viaje.',
  'Registrati': 'Regístrate',
  'Tracce scaricate': 'Pistas descargadas',
  'Utilizzo dati': 'Uso de datos',
  'Registrazioni': 'Grabaciones',
  'Photos': 'Photos',
  'Waypoint': 'Waypoint',
  'Nome': 'Nombre',
  'inserisci il tuo nome': 'Inserta tu nombre',
  "E' necessario inserire un nome": 'Se debe introducir un nombre',
  'Email': 'Email',
  "E' necessario inserire una email": 'Es necesario insertar un correo electrónico',
  "L'email inserita non è un'email valida": 'El correo electrónico no es válido',
  'Codice Fiscale': 'Código Fiscal',
  'Perché ti chiediamo il CF?': '¿Por qué te pedimos el Código Fiscal?',
  'Il codice fiscale inserito non è valido': 'El código fiscal no es válido',
  'inserisci password': 'Introducir contraseña',
  "E' necessario inserire la password": 'Se debe ingresar una contraseña',
  'Conferma password': 'Confirmar Contraseña',
  'Ripeti password': 'Repita la contraseña',
  "E' necessario confermare la password": 'Se requiere confirmación de contraseña',
  'La conferma non corrisponde con la password inserita sopra':
    'La confirmación no coincide con la contraseña ingresada anteriormente',
  'Cliccando su "Registrati" accetti la nostra': 'Al hacer clic en "Registrarse" acepta nuestra',
  'e i': 'e i',
  'Termini e condizioni': 'Términos y condiciones',
  "Errore durante la registrazione dell'utente": 'Error durante el registro del usuario',
  'Registrazione in corso': 'Inscripción en proceso',
  'Perchè ti chiediamo il Codice Fiscale?': '¿Por qué te pedimos el Código Fiscal?',
  'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!':
    'Si eres Socio CAI, introduce tu CF al registrarte. ¡La descarga de las etapas del CAI Sentiero Italia será automáticamente gratuita para ti!',
  "Origine dell'immagine": 'Fuente de la imagen',
  'Annulla': 'Cancelar',
  'Dalla libreria': 'De la biblioteca',
  'Scatta una foto': 'Toma una fotografía',
  'Carica File': 'Carga archivo',
  'Trascina qui il tuo file o clicca per selezionare':
    'Arrastra tu archivo o haz clic para seleccionar',
  'Accetta i seguenti formati': 'Acepta los siguientes formatos',
  'Tipo di file non supportato': 'Tipo de archivo no soportado',
  'Il file non contiene una geometria valida': 'El archivo no contiene una geometría válida',
  'Errore durante la lettura del file, riprova': 'Error al leer el archivo, inténtalo de nuevo',
  'Si è verificato un errore durante il salvataggio della traccia. Riprova':
    'Se ha producido un error al guardar la ruta. Inténtalo de nuevo',
  'La traccia è stata salvata correttamente': 'La ruta se ha guardado correctamente',
  'Scarica il tracciato GPX': 'Descargar la ruta GPX',
  'Scarica il tracciato KML': 'Descargar la ruta KML',
  'Scarica il tracciato GEOJSON': 'Descargar la ruta GEOJSON',
  'Link utili': 'Enlaces útiles',
  'apri pdf': 'Abrir PDF',
  'pendenza': 'Pendiente',
  'Galleria': 'Galería',
  'resetta la memoria': 'Restablecer la memoria',
  'rimani acceso': 'Qëndro i ndezur',
  'forza il dispositivo a non spegnersi': 'Detyro pajisjen të mos fiket',
  'PAGINE': 'PÁGINAS',
  'I tuoi dati': 'Sus datos',
  'pages.profile.projectlink': 'Proyecto',
  'pages.profile.disclaimerlink': 'Aviso',
  'pages.profile.creditslink': 'Créditos',
  'pages.profile.privacylink': 'Privacidad',
  'pages.profile.title': 'Perfil',
  'MEMORIA': 'MEMORIA',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.':
    'Distancia expresada en metros que indica la frecuencia de detección de la posición, cuanto menor sea el filtro de distancia, mayor será el consumo de la batería.',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni":
    'Para registrar rutas y puntos de interés correctamente, habilita la ubicación en las configuraciones.',
  'I miei percorsi': 'Mis rutas',
  'Sentieri': 'Senderos',
  'Sentiero': 'Sendero',
  'layers': 'Layers',
  '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>':
    '<span class="green">Nivel 1: tramos no afectados por la alta altitud (altitud menor de {{orange}} metros)</span>',
  '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>':
    '<span class="orange">Nivel 2: tramos parcialmente en alta altitud (altitud entre {{orange}} metros y {{red}} metros)</span>',
  '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>':
    '<span class="red">Nivel 3: en alta altitud (altitud superior a {{red}} metros)</span>',
  'Un utente è già stato registrato con questa email.':
    'Un usuario ya está registrado con esta dirección de correo electrónico.',
  "L'email inserita non è corretta. Per favore, riprova.":
    'El correo electrónico introducido no es correcto. Por favor, inténtalo de nuevo.',
  'La password inserita non è corretta. Per favore, riprova.':
    'La contraseña introducida no es correcta. Por favor, inténtalo de nuevo.',
  'Errore': 'Error',
  'Tempo': 'Tiempo',
  'Velocità media': 'Velocidad media',
  'Velocità massima': 'Velocidad máxima',
  'Tipologia di form': 'Tipo de formulario',
  'Seleziona il tipo di form': 'Selecciona el tipo de formulario',
  'File selezionato': 'Archivo seleccionado',
  'Carica': 'Cargar',
  'Aggiornamento effettuato con successo': 'Actualización realizada con éxito',
  'Ops!': '¡Ups!',
  'Non è stato possibile aggiornare, riprova più tardi':
    'No fue posible actualizar, inténtalo de nuevo más tarde',
  'Eliminazione effettuata con successo': 'Eliminación realizada con éxito',
  'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.':
    '¿Está seguro de que desea eliminar este POI? La eliminación es irreversible.',
  'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.':
    '¿Está seguro de que desea eliminar esta ruta? La eliminación es irreversible.',
  'Login effettuato con successo': 'Inicio de sesión exitoso',
  'Logout effettuato con successo': 'Cierre de sesión exitoso',
  'Ottieni indicazioni': 'Obtener indicaciones',
  'Mostra altro': 'Mostrar más',
  'Distanza da te': 'Distancia de ti',
  'Mostra meno': 'Mostrar menos',
  'Mostra tutti': 'Mostrar todos',
  'Lunghezza': 'Longitud',
  'Orario previsto': 'Tiempo previsto',
  'Dimensione': 'Tamaño',
  'questo campo è obbligatorio': 'este campo es obligatorio',
  'Quota': 'Elevación',
  'I miei downloads': 'Mis descargas',
  'foto dalla galleria': 'foto de la galería',
  'Dimensione massime: 3 photo': 'Tamaño máximo: 3 fotos',
  'Aggiungi': 'Agregar',
  'Foto': 'Foto',
  '(max 3 photo)': '(máx 3 fotos)',
  'art-and-culture': 'Arte y cultura',
  'tourism': 'Turismo',
  'e-bike': 'Bicicleta eléctrica',
  'touring-bike': 'Bicicleta de turismo',
  'train-trekking': 'Trekking en tren',
  'road-bike': 'Bicicleta de carretera',
  'ciaspole': 'Raquetas de nieve',
  'adventure': 'Aventura',
  'swimming-snorkeling': 'Natación y esnórquel',
  'birdwatching': 'Observación de aves',
  'oeno-gastronomy': 'Enogastronomía',
  'nordic-walking': 'Caminata nórdica',
  'joelette': 'Joëlette',
  'mtb': 'MTB',
  'mountain-bike': 'Bicicleta de montaña',
  'Ottieni le indicazioni su Google Maps': 'Obtener indicaciones en Google Maps',
  'Per il punto di partenza': 'Para el punto de partida',
  "Per il punto più vicino in linea d'aria": 'Para el punto más cercano en línea de vista',
  'Tipo di form': 'Tipo de formulario',
  'massimo': 'máximo',
  'foto': 'fotos',
  'Carica foto dalla libreria': 'Cargar fotos de la biblioteca',
  'Luogo': 'Lugar',
  'Luoghi': 'Lugares',
  'Percorso': 'Ruta',
  'Percorsi': 'Rutas',
  'salva': 'guardar',
  'Il salvataggio è stato completato': 'El guardado se ha completado',
  'Stai modificando le coordinate del POI, vuoi continuare?':
    'Estás modificando las coordenadas del POI, ¿quieres continuar?',
  'No': 'No',
  'Sì': 'Sí',
  'Attenzione': 'Atención',
  'Disegna': 'Dibujar',
  'Esci': 'Salir',
  'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.':
    'Has guardado correctamente tu waypoint. Puedes verlo accediendo a tu perfil.',
  'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni':
    'Al hacer clic en "Registrarse" acepta nuestra política de privacidad y nuestros términos y condiciones',
  'culture-history': 'Cultura y historia',
  'environmental-education': 'Educación ambiental',
  'eating-sleeping': 'Comer y dormir',
  'by-car': 'En coche',
  'Eliminazione': 'Eliminación',
  'Elimina': 'Eliminar',
  'Sei sicuro di voler eliminare questi dati?': '¿Está seguro de que desea eliminar estos datos?',
  'Modifica consenso dati': 'Modificar consentimiento de datos',
  'Dati non sincronizzati': 'Datos no sincronizados',
  'Lingua': 'Idioma',
  'Azione irreversibile': 'Acción irreversible',
  'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.':
    '¿Está seguro de que desea eliminar su cuenta? Es necesario escribir "delete account" para proceder.',
  'Digita "delete account"': 'Escribe "delete account"',
  'Conferma': 'Confirmar',
  'La conferma non corrisponde. Digita "delete account" per procedere.':
    'La confirmación no coincide. Escribe "delete account" para proceder.',
  'Elimina account': 'Eliminar cuenta',
  'Aggiornamento disponibile': 'Actualización disponible',
  "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.":
    'Una nueva versión de la aplicación está disponible. Actualiza ahora para obtener las últimas funciones y mejoras.',
  'Aggiorna ora': 'Actualizar ahora',
  'Più tardi': 'Más tarde',
  'Versione disponibile': 'Versión disponible',
  'È stata rilevata una registrazione interrotta. Vuoi riprenderla?':
    'Se ha detectado una grabación interrumpida. ¿Quieres continuar?',
  'Riprendi': 'Continuar',
  'Info': 'Info',
  'Chiudi': 'Cerrar',
  'Store non disponibile': 'Tienda no disponible',
  "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.":
    'No fue posible abrir la tienda directamente. Intenta abrir manualmente la página de la app en la tienda.',
  'Aggiornamento obbligatorio': 'Actualización obligatoria',
  "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.":
    'Para seguir utilizando la aplicación, debes instalar la última versión disponible.',
  "È disponibile una nuova versione dell'app.":
    'Una nueva versión de la aplicación está disponible.',
  'Dove': 'Donde',
  'Regione': 'Región',
  'Provincia': 'Provincia',
  'Comune': 'Municipio',
  'layer': 'Layer',
  'Nessun risultato': 'Sin resultados',
};
